import React from 'react';

const Email = () => (
  <svg
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
  >
    <g>
      <path
        className="semiCircle"
        fill="#16a085"
        d="M12,1c6.075,0,11,4.925,11,11s-4.925,11-11,11S1,18.075,1,12S5.925,1,12,1"
      />
      <path
        fill="#FFFFFF"
        d="M11.6,18.202c-1.61,0-3.097-0.548-4.187-1.542c-1.161-1.059-1.775-2.512-1.775-4.199
            c0-1.876,0.691-3.625,1.945-4.921c1.312-1.357,3.16-2.104,5.204-2.104c1.661,0,3.091,0.523,4.136,1.512
            C17.94,7.912,18.5,9.268,18.5,10.766c0,2.89-1.784,4.403-3.547,4.403c-0.51,0-0.881-0.128-1.135-0.39
            c-0.155-0.16-0.263-0.375-0.32-0.637l-0.041-0.191l-0.125,0.152c-0.693,0.846-1.56,1.256-2.647,1.256
            c-1.166,0-2.347-0.871-2.347-2.536c0-1.19,0.508-2.368,1.394-3.229c0.931-0.906,2.199-1.405,3.571-1.405
            c0.651,0,1.317,0.099,1.875,0.277c0.273,0.087,0.436,0.367,0.379,0.65l-0.621,3.076c-0.135,0.636-0.263,1.402-0.057,1.665
            c0.041,0.051,0.118,0.12,0.328,0.126l0.035,0.001c0.906,0,1.874-1.243,1.874-3.093c0-2.667-1.717-4.323-4.481-4.323
            c-3.241,0-5.593,2.434-5.593,5.787c0,2.8,1.917,4.681,4.769,4.681c0.839,0,1.764-0.183,2.538-0.501l0.05-0.01
            c0.115,0,0.211,0.207,0.313,0.427l0.016,0.036l0.046,0.096c0.078,0.161,0.151,0.313,0.112,0.415
            c-0.022,0.058-0.082,0.105-0.184,0.146C13.792,18.025,12.807,18.202,11.6,18.202 M12.998,9.637c-1.566,0-2.891,1.399-2.891,3.056
            c0,0.281,0.08,1.201,1.109,1.201c0.983,0,1.982-1.236,2.185-2.301l0.325-1.616l-0.041-0.197l-0.17-0.106
            C13.355,9.65,13.181,9.637,12.998,9.637"
      />
      <path
        fill="#E9E8E8"
        d="M4.222,19.778L4.222,19.778c0.443,0.442,0.923,0.848,1.436,1.21C5.145,20.626,4.665,20.221,4.222,19.778
            M19.778,4.222L19.778,4.222c0.443,0.443,0.849,0.924,1.211,1.438C20.627,5.146,20.222,4.665,19.778,4.222"
      />
      <path
        className="semiCircle"
        fill="#16a085"
        d="M13.652,10.348l-3.24,3.24c0.165,0.177,0.417,0.307,0.804,0.307c0.983,0,1.982-1.236,2.185-2.301
            L13.652,10.348 M16.088,7.912L15.399,8.6c0.132,0.13,0.196,0.322,0.157,0.517l-0.621,3.076c-0.135,0.636-0.263,1.402-0.057,1.665
            c0.041,0.051,0.118,0.12,0.328,0.126l0.035,0.001c0.906,0,1.874-1.243,1.874-3.093C17.116,9.663,16.752,8.648,16.088,7.912
            M19.778,4.222l-2.789,2.79C17.964,7.97,18.5,9.3,18.5,10.766c0,2.89-1.784,4.403-3.547,4.403c-0.51,0-0.881-0.128-1.135-0.39
            c-0.155-0.16-0.263-0.375-0.32-0.637l-0.041-0.191l-0.125,0.152c-0.693,0.846-1.56,1.256-2.647,1.256
            c-0.536,0-1.074-0.184-1.5-0.544l-0.878,0.879c0.838,0.852,2.049,1.341,3.505,1.341c0.839,0,1.764-0.183,2.538-0.501l0.05-0.01
            c0.115,0,0.211,0.207,0.313,0.427l0.016,0.036l0.046,0.096c0.078,0.161,0.151,0.313,0.112,0.415
            c-0.022,0.058-0.082,0.105-0.184,0.146c-0.909,0.381-1.895,0.558-3.101,0.558c-1.61,0-3.097-0.548-4.187-1.542
            c-0.013-0.012-0.025-0.023-0.039-0.035l-3.153,3.153c0.443,0.442,0.923,0.848,1.436,1.21C7.45,22.256,9.638,23,12,23
            c6.075,0,11-4.925,11-11c0-0.019,0-0.039,0-0.058c-0.012-2.339-0.755-4.506-2.011-6.283C20.627,5.146,20.222,4.665,19.778,4.222"
      />
      <path
        fill="#E9E8E8"
        d="M8.306,15.694l-0.931,0.931c0.013,0.012,0.026,0.023,0.039,0.035c1.09,0.994,2.577,1.542,4.187,1.542
            c1.207,0,2.192-0.177,3.101-0.558c0.102-0.041,0.161-0.089,0.184-0.146c0.039-0.103-0.034-0.254-0.112-0.415l-0.046-0.096
            l-0.016-0.036c-0.102-0.22-0.197-0.427-0.313-0.427l-0.05,0.01c-0.773,0.318-1.698,0.501-2.538,0.501
            C10.355,17.035,9.144,16.546,8.306,15.694 M16.989,7.011l-0.901,0.9c0.664,0.737,1.028,1.751,1.028,2.979
            c0,1.85-0.968,3.093-1.874,3.093l-0.035-0.001c-0.21-0.006-0.287-0.075-0.328-0.126c-0.206-0.263-0.078-1.028,0.057-1.665
            l0.621-3.076c0.039-0.194-0.025-0.387-0.157-0.517l-1.747,1.748l-0.251,1.246c-0.202,1.064-1.201,2.301-2.185,2.301
            c-0.387,0-0.64-0.13-0.804-0.307l-1.228,1.228c0.426,0.36,0.964,0.544,1.5,0.544c1.087,0,1.954-0.41,2.647-1.256l0.125-0.152
            l0.041,0.191c0.058,0.262,0.165,0.477,0.32,0.637c0.254,0.262,0.625,0.39,1.135,0.39c1.763,0,3.547-1.513,3.547-4.403
            C18.5,9.3,17.964,7.97,16.989,7.011"
      />
    </g>
  </svg>
);

export default Email;
